import Model from '@/models/Model';

export default class Subscription extends Model {
    get route () {
        return 'subscriptions';
    }

    static get className () {
        return 'Subscription';
    }
}
